import React, { useState, useCallback } from "react";
import { useQueryWithSimpleErrorHandling, useSimpleError, useInsuranceTypeConfiguration } from "hooks";
import { useMutation } from "features/common/security/hooks";
import { insuranceTypeNames } from "constants/defaultValues";
import { INSURANCE_DOCUMENTS_FOR_CHECK_QUERY } from "features/settings/queries";
import { CHECK_CASCO_CROSS_CHECK_FLOW } from "../../../mutations";
import CrossCheckFlowComponent from "../CrossCheckFlowComponent";
import { useCrossCheckUtils } from "../utils";
import { useTranslation } from "react-i18next";

const CascoCrossCheckFlowContainer = () => {
  const showError = useSimpleError();
  const { t } = useTranslation();
  const { updateCrossChecksSelectedStatus } = useCrossCheckUtils();
  const { cascoInsuranceTypeConfiguration } = useInsuranceTypeConfiguration(new Array(insuranceTypeNames.CASCO));
  const cascoTypeCode = cascoInsuranceTypeConfiguration?.PropertyCode;
  const [checkCascoData, setCheckCascoData] = useState([]);
  const [crossCheckResults, setCrossCheckResults] = useState([]);

  useQueryWithSimpleErrorHandling(INSURANCE_DOCUMENTS_FOR_CHECK_QUERY, {
    variables: { insuranceTypeCode: cascoTypeCode },
    skip: !cascoTypeCode,
    onCompleted: data => {
      const documents = data?.insuranceDocumentsForCheck || [];
      setCheckCascoData(
        documents.map(x => ({
          ...x,
          selected: false
        }))
      );
    }
  });

  const [checkCASCOCrossCheckFlow] = useMutation(CHECK_CASCO_CROSS_CHECK_FLOW, {
    onError: error => {
      showError(error);
    }
  });

  const handleSelect = useCallback(documentId => {
    setCheckCascoData(prev => prev.map(x => (x.documentId === documentId ? { ...x, selected: !x.selected } : x)));
  }, []);

  const handleSelectAll = useCallback(() => {
    setCheckCascoData(prev => {
      const allSelected = prev.every(x => x.selected);
      return prev.map(x => ({ ...x, selected: !allSelected }));
    });
  }, []);

  const handleCheckCascoQuotations = () => {
    const selected = checkCascoData.filter(x => x.selected);
    checkCASCOCrossCheckFlow({
      variables: {
        input: {
          documentIds: selected.map(x => x.documentId)
        }
      }
    });
    setCrossCheckResults(
      selected.map(({ documentId, documentNumber, documentDate }) => ({
        documentId,
        documentNumber,
        documentDate
      }))
    );
    var crossChecksSelected = selected.map(({ documentId }) => ({ documentId, loading: true }));
    updateCrossChecksSelectedStatus(crossChecksSelected);
  };

  return (
    <CrossCheckFlowComponent
      crossCheckResults={crossCheckResults}
      checkData={checkCascoData}
      onSelect={handleSelect}
      onSelectAll={handleSelectAll}
      onCheckCrossFlow={handleCheckCascoQuotations}
      title={t("Settings.InsuranceIntegrationChecks.CascoCheck.CrossCheck")}
      insuranceTypeCode={cascoTypeCode}
    />
  );
};

export default CascoCrossCheckFlowContainer;
